const state = {
  currentPage: '',
}

const actions = {
  updateCurrentPage({ commit }, payload) {
    commit('updateCurrentPage', payload)
  },
}

const getters = {
  getCurrentPage: state => {
    return state.currentPage
  },
}

const mutations = {
  updateCurrentPage: (state, payload) => {
    state.currentPage = payload.currentPage
  },
}

export default {
  state,
  actions,
  getters,
  mutations
}